import { ArticleCardData } from "@baseComponents/ArticleCard";

export const articleCardPortLocalized: {
  [locale: string]: ArticleCardData;
} = {
  en: {
    area: "automation",
    image: {
      src: "/portfolio_automation/port/main_img.png",
      alt: "View of the airport terminal with passenger check-in counters",
    },
    title: "App for managing tourist transport",
    description:
      "We helped Mr. Shuttle, a professional tour operator, build an application for managing tourist and business transport services. The solution supports airport transfers, intercity routes, and day trips — improving logistics and client experience in the travel industry.",
    date: new Date("2023-11-20"),
    timeToRead: 6,
    href: "/portfolio/port",
  },
  pl: {
    area: "automation",
    image: {
      src: "/portfolio_automation/port/main_img.png",
      alt: "Widok na terminal lotniska ze stanowiskami do odprawy pasażerów",
    },
    title: "Aplikacja do zarządzania transportem turystycznym",
    description:
      "Wspieraliśmy firmę Mr. Shuttle, doświadczonego operatora turystycznego, w stworzeniu aplikacji do zarządzania usługami transportu dla turystów i podróżnych biznesowych. Rozwiązanie obsługuje transfery lotniskowe, międzymiastowe i wycieczki jednodniowe.",
    date: new Date("2023-11-20"),
    timeToRead: 6,
    href: "/portfolio/port",
  },
};
